import {Component, EventEmitter, Output} from '@angular/core';
import {AlertController, NavController, NavParams} from "ionic-angular";
import {CommonProvider} from "../../providers/common/common";
import {AccountProvider} from "../../providers/account/account";
import {TranslateService} from "@ngx-translate/core";

import * as _ from "lodash";
import APP_CONFIG from "../../app/app.config";

/**
 * Generated class for the ParentalGateComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'parental-gate',
  templateUrl: 'parental-gate.html'
})
export class ParentalGateComponent {

    @Output() onClose = new EventEmitter();

    public questionKey = 0;
    public answerNumbers = [];

    public numbers: any = [
        {key: 1, active: false},
        {key: 2, active: false},
        {key: 3, active: false},
        {key: 4, active: false},
        {key: 5, active: false},
        {key: 6, active: false},
        {key: 7, active: false},
        {key: 8, active: false},
        {key: 9, active: false}
    ];

    public questions: any = [
        {key: '1, 2, 4', title: 'One, Two, Four'},
        {key: '3, 2, 4', title: 'Three, Two, Four'},
        {key: '3, 2, 5', title: 'Three, Two, Five'},
        {key: '6, 3, 1', title: 'Six, Three, One'},
        {key: '4, 8, 9', title: 'Four, Eight, Nine'},
        {key: '8, 7, 2', title: 'Eight, Seven, Two'}
    ];

    constructor(public navCtrl: NavController,
                public navParams: NavParams,
                public commonProvider: CommonProvider,
                public accountProvider: AccountProvider,
                public alertCtrl: AlertController,
                public translate: TranslateService) {
    }

    ionViewDidLoad() {
        this.randomQuestion();
    }

    appendNumber(number) {
        number.active = !!!number.active;

        if (this.answerNumbers.length < 3) {
            this.answerNumbers.push(number.key);
        }

        if (this.answerNumbers.length < 3) {
            return;
        }

        const isSuccess = this.answerNumbers.join(', ') === this.questions[this.questionKey].key;
        if (isSuccess) {
            this.onClose.emit(true);
        } else {
            this.showError();
            this.reset();
        }
    }

    randomQuestion() {
        this.questionKey = this.commonProvider.getRandomInt(0, (this.questions.length - 1));
    }

    playSoundParental() {
        const audio = new Audio(APP_CONFIG.appURL + '/' + `assets/sounds/${window.localStorage.getItem('LANG')}/parental-gate.mp3`);
        audio.play();
    }

    reset() {
        this.answerNumbers = [];

        _.forEach(this.numbers, number => {
            number.active = false;
        });
    }

    showError() {
        const alert = this.alertCtrl.create({
            title: this.translate.instant("ALERT"),
            subTitle: this.translate.instant("ANSWER_INVALID"),
            buttons: [this.translate.instant("CLOSE")]
        });
        alert.present();
    }
}



// WEBPACK FOOTER //
// ./src/components/parental-gate/parental-gate.ts